import { Box, Card, Select, TextField, Typography } from '@material-ui/core';
import styled from 'styled-components'


export const StyledPostTitle = styled(Typography)`
  font-size: 12px !important;
  font-weight: 500 !important;
  text-align: left;
  margin-bottom: 10px !important;
  color: ${props => props.theme.colors.accent};
  overflow-wrap: anywhere;
  overflow: hidden;
`
export const StyledReportHeader = styled(Typography)`
  font-size: 14px !important;
  font-weight: 500 !important;
  text-align: left;
  margin-bottom: 5px !important;
  color: ${props => props.theme.colors.accent1};
`
export const StyledSelect = styled(Select)`
  && {
    border: 1px solid;
    text-align: left;
    font-size: 16px;
    background-color: ${({ theme }) => theme.colors.backgroundComplementI};
    color: ${({ theme }) => theme.colors.ligthGrey};
    font-weight: bold;
  }
`
export const StyledTextField = styled(TextField)`
  && .MuiInput-root {
    border: 2px solid ;
    background-color: ${props => props.theme.colors.backgroundComplementI};
    margin-bottom: 0.3em;
  }
  input[type='text']::placeholder {
    text-align: right;
  }
  position: relative;

  && .MuiInputAdornment-root {
    padding-left: 1em;
  }
  && .MuiInputAdornment-root p {
    color: inherit !important;
  }
`
export const StyledTextBox = styled(Box)`
  height: 10px !important;
  width: 100% !important;
  margin-top: 2em !important;
  margin-bottom: 10em !important;
`
export const StyledReportAreaBox = styled(Box)`
  height: 50px !important;
  width: 100% !important;
  text-align: start;
`

export const StyledMentionsTitle = styled(Box)`
  && {
    word-break: break-all;
  }

  && a, && a:link, && a:visited {
    color: ${props => props.theme.colors.primary};
  }
`
export const StyledCard = styled(Card)`
  && {
    overflow: visible;
    word-break: break-all;
  }
`